import {
  ActionsWrapper,
  Dots,
} from 'components/Table/helpers/CellActions/CellActionsStyled';
import styled, { StyledProps } from 'styled-components/macro';

export type Properties = StyledProps<{
  isOpen?: boolean;
}>;

export const AccordionActions = styled.div`
   {
    display: flex;
    white-space: nowrap;

    button {
      background-color: none;
      color: #0076c0;
      border: none;
      margin-right: 5px;
      font-size: 14px;
    }

    button:focus:not(:focus-visible) {
      outline: none;
      box-shadow: none;
      text-decoration: none;
    }

    button:hover {
      text-decoration: none;
    }

    div.dropdown > ${Dots} {
      padding-top: 10px !important;
    }

    div.dropdown > ${ActionsWrapper} {
      top: unset;
      left: -14px;
      width: unset;
    }
  }
`;

export const AccordionDescription = styled.small`
  font-size: 9px !important;
  padding: 7px 10px 0.5rem 10px;
  font-style: italic;
  white-space: nowrap;
  flex: 1;
`;

export const AccordionTitle = styled.h5`
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AccordionArrow = styled.div`
  margin-left: 20px;
  cursor: pointer;
`;

export const ContentPane = styled.div`
  background-color: white;
  margin: 10px;
`;

export const AccordionContent = styled.div`
  padding: 0 0 0px;
  display: flex;

  & table {
    background-color: white;

    & thead {
      & th {
        vertical-align: top;

        & span.badge {
          line-height: unset;
          font-weight: 400;
        }
      }
    }

    & tbody {
      & tr {
        & td {
          padding-top: 0px;
        }
      }
    }
  }
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 53px;
`;

export const BenchmarkMetadataAccordion = styled.div<Properties>`
  background: #e8edf2;
  border-radius: 6px;
  padding: 10px;
  margin: 20px;

  ${AccordionContent} {
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  }
  ${AccordionArrow} {
    ${(props) => (props.isOpen ? 'padding-top: 5px' : '')};
    ${(props) => (props.isOpen ? 'padding-right: 5px' : '')};
    transform: ${(props) => (props.isOpen ? 'rotate(0deg)' : 'rotate(-90deg)')};
  }

  table.table-sm {
    height: 100%;

    tbody {
      tr {
        th {
          padding-left: 20px;

          & span.badge {
            line-height: unset;
            font-weight: 400;
          }
        }

        td {
          padding-right: 20px;
          text-align: right;
        }
      }
    }
  }
`;
